
import axios from 'axios';
import { getServerError } from '../error/error-service';
import { ApiFullUserFilter, ApiCreateUserFilterParams, ApiUpdateUserFilterParams } from './user-filter-service.types';

const DocApiBaseUrl = `/doc-api`;

export const getUserFilterList = (groupCode: string) => {
    return axios.get<ApiFullUserFilter[]>(`${DocApiBaseUrl}/user-filter`, { params: { groupCode } })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);
        });
}

export const createUserFilter = (data: ApiCreateUserFilterParams) => {
    return axios.post<{ id: number }>(`${DocApiBaseUrl}/user-filter`, data)
        .then((response) => {
            return response.data.id;
        })
        .catch((error) => {
            throw getServerError(error);
        });
}


export const updateUserFilter = (filterId: number, data: ApiUpdateUserFilterParams) => {
    return axios.put(`${DocApiBaseUrl}/user-filter/${filterId}`, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);
        });
}


export const deleteUserFilter = (filterId: number) => {
    return axios.delete(`${DocApiBaseUrl}/user-filter/${filterId}`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);
        });
}

